import { ShapeProps } from './types';

export const Circle = ({ className }: ShapeProps) => (
    <svg
        className={className}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="11.0942"
            cy="10.8999"
            r="9"
            stroke="#313131"
            strokeWidth="2.7"
            strokeLinejoin="round"
        />
    </svg>
);
